import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stanOplatyText',
})
export class StanOplatyTextPipe implements PipeTransform {
  transform(oplata: number): string {
    if (oplata > 0) {
      return 'text-danger';
    } else if (oplata === 0) {
      return 'text-success';
    }
    return '';
  }
}
